import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { trackLaunch } from "@/lib/api";

export const neon = "rounded-3xl border border-[#3b3f9e]/60 bg-[linear-gradient(160deg,rgba(30,27,90,.75),rgba(10,10,40,.85))] shadow-[0_0_40px_-12px_rgba(124,58,237,.6)] backdrop-blur-md";

export function useLaunch() {
  const nav = useNavigate();
  return (app) => {
    if (!app?.launch_url) return nav(`/app/${app.slug}`);
    if (!app.launch_url.startsWith("/") && !navigator.onLine) return toast.error(`${app.name} needs an internet connection`);
    trackLaunch(app.slug);
    if (app.launch_url.startsWith("/")) nav(app.launch_url);
    else window.location.href = app.launch_url;
  };
}

export function Move({ move, testid }) {
  if (move == null) return <span className="text-[10px] font-black text-cyan-300" data-testid={testid}>NEW</span>;
  if (move > 0) return <span className="text-sm font-black text-emerald-400" data-testid={testid}>▲ {move}</span>;
  if (move < 0) return <span className="text-sm font-black text-rose-400" data-testid={testid}>▼ {-move}</span>;
  return <span className="text-sm font-bold text-white/50" data-testid={testid}>— 0</span>;
}

export const Icon = ({ app, size = "w-14 h-14" }) => (
  <img src={app?.icon_url} alt="" loading="lazy" className={`${size} rounded-2xl object-cover shadow-[0_0_18px_-4px_rgba(56,189,248,.6)] bg-[#1e1b4b]`} />
);

export const ago = (iso) => {
  const s = (Date.now() - new Date(iso)) / 1000;
  return s < 3600 ? `${Math.max(1, Math.floor(s / 60))}m ago` : s < 86400 ? `${Math.floor(s / 3600)}h ago` : `${Math.floor(s / 86400)}d ago`;
};
